<div id="popup_makeCenter">
  <div id="popup_makeCenter_close" (click)="onCloseClick($event)"></div>
  <div class="pop-up-container">
    <img
      class="popupimg"
      src="./assets/images/common/quick_start_gold_bg.webp"
    />
    <img
      class="popupimg_quickstart_banner"
      src="./assets/images/lobby_sprite_images/lang_sprite_images/{{
        currentLanguage
      }}_fcg/{{ currentLanguage }}_quickstart_banner@2x.webp"
    />
    <img
      *ngIf="this.popUpTo == 'LiveDealerNoSeat'"
      class="separator_horizontal_img_top"
      src="./assets/images/common/separator_horizontal@2x.webp"
    />
    <img
      *ngIf="this.popUpTo == 'LiveDealerNoSeat'"
      class="separator_horizontal_img_bottom"
      src="./assets/images/common/separator_horizontal@2x.webp"
    />
    <img
      *ngIf="this.popUpTo == 'cardShuffling'"
      class="live_dealer_shuffling_alert_overlay"
      src="./assets/images/common/live_dealer_shuffling_alert_overlay@2x.webp"
    />

    <div class="lang-specific-text-content_LANG00860">
      <span
        class="lang-specific-font-name-menu lang-specific-right_to_left_direction playnow_text"
        >{{
          popUpTo == 'cardShuffling'
            ? ('LANG01099' | translate)
            : ('LANG00860' | translate)
        }}</span
      >
    </div>
    <img
      *ngIf="this.popUpTo == 'LiveDealerNoSeat'"
      class="live_dealer_to_live_casino_overlay_img"
      [appImageSprite]="'game_status_underlay@2x'"
      [params]="menu_icons"
    />
    <img
      *ngIf="this.popUpTo == 'LiveDealerNoSeat'"
      class="live_dealer_icon_helping_hand"
      [appImageSprite]="'live_dealer_icon_helping_hand@2x'"
      [params]="menu_icons"
    />
    <div
      *ngIf="this.popUpTo == 'LiveDealerNoSeat'"
      class="lang-specific-text-content_LANG01097"
    >
      <span
        class="lang-specific-font-name-menu lang-specific-right_to_left_direction playnow_text"
        >{{ 'LANG01097' | translate }}</span
      >
      <span
        class="lang-specific-font-name-menu lang-specific-right_to_left_direction playnow_text"
        >{{ 'LANG01098' | translate }}</span
      >
    </div>
    <div
      *ngIf="this.popUpTo == 'cardShuffling'"
      class="lang-specific-text-content_LANG01100"
    >
      <span
        class="lang-specific-font-name-menu lang-specific-right_to_left_direction playnow_text"
        >{{ 'LANG01100' | translate }}</span
      >
    </div>
    <img
      *ngIf="this.popUpTo == 'LiveDealerNoSeat'"
      class="separator_horizontal_img_playnow"
      src="./assets/images/common/separator_horizontal@2x.webp"
    />
    <img
      class="closeiconImg"
      src="./assets/images/lobby_sprite_images/common/menu_sprite_images/close.webp"
      (click)="onCloseClick($event)"
    />
    <div
      class="lang-specific-text-content-insuff-LD"
      (click)="onRedirectClick(LDSeatsObj)"
    >
      <img
        class="livecasino_brownImg"
        [ngClass]="'brownImg-' + popUpTo"
        [appImageSprite]="
          popUpTo == 'cardShuffling'
            ? 'live_dealer_shuffling_camera_icon@2x'
            : 'livecasino_brown'
        "
        [params]="menu_icons"
      />
      <span
        class="lang-specific-font-name-menu lang-specific-right_to_left_direction playnow_text"
        >{{
          this.popUpTo == 'cardShuffling'
            ? ('LANG01101' | translate)
            : ('LANG00861' | translate)
        }}
      </span>
      <img
        class="arrow_icon_brownImg"
        [appImageSprite]="'arrow_icon_brown'"
        [params]="menu_icons"
      />
    </div>
  </div>
</div>
